import React from 'react';
import { Button } from '@ver-uds/react';
import { Icon } from '@ver-uds/uswds-react';
import { paramCase } from 'param-case';
import { HelpModalProps } from '../../HelpModal';
import HelpModalContent from '../../../constants/HelpModalContent';

export interface LabelHintProps {
  label: string;
  openModal(content: HelpModalProps['modalContent']): void;
  className?: string;
}

const LabelHint = ({ label, openModal, className }: LabelHintProps): JSX.Element => {
  let HelpModalContentIdentifier: { header: string; body: React.ReactNode };
  // eslint-disable-next-line default-case
  switch (label) {
    case 'Doing Business As (DBA) Name':
      HelpModalContentIdentifier = HelpModalContent.dba;
      break;
    case 'Employer Identification Number (EIN)':
      HelpModalContentIdentifier = HelpModalContent.employerIdentification;
      break;
    case 'NAICS Code':
      HelpModalContentIdentifier = HelpModalContent.naicsCode;
      break;
    case 'DUNS Number':
      HelpModalContentIdentifier = HelpModalContent.duns;
      break;
    case 'Unique Entity Identifier (UEI)':
      HelpModalContentIdentifier = HelpModalContent.uei;
      break;
    case 'Hiring Sites':
      HelpModalContentIdentifier = HelpModalContent.hiringSites;
      break;
    case 'Memorandum of Understanding (MOU) Signatory':
      HelpModalContentIdentifier = HelpModalContent.mouSignatory;
      break;
    case 'Program Administrator(s)':
      HelpModalContentIdentifier = HelpModalContent.programAdministrator;
      break;
    case 'Federal Contractors Subjected to the FAR E-Verify Clause':
      HelpModalContentIdentifier = HelpModalContent.federalContractorsSubjectFAREVerifyClause;
      break;
  }
  return (
    <Button
      variant="tertiary"
      type="button"
      onClick={(): void => openModal(HelpModalContentIdentifier)}
      style={{ marginTop: '0' }}
      className={className}
    >
      <Icon
        name="help"
        title={{
          id: `help-${paramCase(label)}`,
          text: `Read more about ${label} in the help modal`,
        }}
      />
    </Button>
  );
};

export default LabelHint;
